module.exports = __webpack_public_path__ + "img/webinars.224e674b.jpg";